var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75007 9.96777L17.0879 11.2778L21.8262 3.58369C22.0863 3.16128 22.7141 2.99207 23.2283 3.20576C23.5795 3.35166 23.8008 3.64739 23.8008 3.97061V17.1368C23.8008 17.6102 23.3336 17.994 22.7573 17.994H3.07816C2.50186 17.994 2.03468 17.6102 2.03468 17.1368C2.03468 16.9357 2.12078 16.741 2.27792 16.5867L8.72822 10.2553C8.97726 10.0108 9.37087 9.90007 9.75007 9.96777ZM14.8945 14.0586L7.55669 12.7486L2.81835 20.4427C2.55821 20.8651 1.93045 21.0343 1.4162 20.8206C1.06509 20.6747 0.84375 20.379 0.84375 20.0558V6.88953C0.84375 6.41614 1.31093 6.03239 1.88723 6.03239H21.5664C22.1427 6.03239 22.6099 6.41614 22.6099 6.88953C22.6099 7.09066 22.5238 7.28538 22.3666 7.43962L15.9163 13.7711C15.6673 14.0156 15.2737 14.1263 14.8945 14.0586Z",
    fill: "#3CDBC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDashboard);
export default __webpack_public_path__ + "static/media/icons_dashboard.484b8fd0.svg";
export { ForwardRef as ReactComponent };